import { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import arrowDownIconGreen from '../../../images/arrow-right-green.svg';
import { FEEDBACK_SUBJECT_KEYS } from '../../../utils/feedbackSubjects';
import {
  FeedbackFormDiv,
  SelectArrowIcon,
  SelectButton,
  SelectDropdown,
  SelectOption,
} from '../../../styles/styles';

const SubjectSelectDropdown = styled(SelectDropdown)`
  align-items: stretch;
`;

const SubjectSelectOption = styled(SelectOption)`
  width: 100%;
  box-sizing: border-box;
  justify-content: flex-start;
  text-align: left;
  padding: 10px 14px;
`;

export default function FeedbackSubjectSelect({ value, onChange, outlined = false }) {
  const { t } = useTranslation('account');
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const handler = (event) => {
      if (!wrapRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const currentLabel = t(`form.subject.${value}`, value);

  return (
    <FeedbackFormDiv width="100%">
      <div ref={wrapRef} style={{ position: 'relative', width: '100%' }}>
        <SelectButton
          type="button"
          width="100%"
          onClick={() => setOpen((prev) => !prev)}
          aria-haspopup="listbox"
          aria-expanded={open}
          style={{
            justifyContent: 'space-between',
            textAlign: 'left',
            height: outlined ? '35px' : undefined,
            boxSizing: 'border-box',
          }}
        >
          <span style={{ textAlign: 'left', flex: 1 }}>{currentLabel}</span>
          <SelectArrowIcon
            src={arrowDownIconGreen}
            style={{ transform: open ? 'rotate(-90deg)' : 'rotate(90deg)' }}
          />
        </SelectButton>

        {open && (
          <div
            style={{
              position: 'absolute',
              zIndex: 20,
              top: '100%',
              left: 0,
              right: 0,
              marginTop: 4,
            }}
          >
            <SubjectSelectDropdown width="100%">
              {FEEDBACK_SUBJECT_KEYS.map((key) => (
                <SubjectSelectOption
                  key={key}
                  role="option"
                  aria-selected={key === value}
                  onClick={() => {
                    onChange(key);
                    setOpen(false);
                  }}
                  style={{ fontWeight: key === value ? 600 : 400 }}
                >
                  {t(`form.subject.${key}`)}
                </SubjectSelectOption>
              ))}
            </SubjectSelectDropdown>
          </div>
        )}
      </div>
    </FeedbackFormDiv>
  );
}
